<template>
    <RichResponseHeadline
        :title="headline"
        class="headline"
    />
    <RichResponseListItem
        iconType="ion"
        :icon="getIconForAbsenceType(AbsenceType.Sickness)"
        title="Krankmelden starten"
        :selectable="false"
        v-on:click="onClick"
        :button="true"
    />
    <AutopilotWizardSickness ref='modal' v-model="modalValue" :showMostRecentAInesMessage=true :initialMonth="initData ?? undefined" />
</template>

<script setup lang="ts">

import {computed, Ref, ref} from "vue";
import RichResponseHeadline from "@/views/Chat/RichResponses/components/RichResponseHeadline.vue";
import AutopilotWizardSickness from "@/views/components/Planning/AutopilotWizardSickness.vue";
import RichResponseListItem from "@/views/Chat/RichResponses/components/RichResponseListItem.vue";
import {getIconForAbsenceType} from "@/helper/absence";
import {AbsenceType} from "@/graphql/generated/graphql";
import {kapitelDateString} from "@/graphql/kapitelTypes";

const props = defineProps<{
    initData: kapitelDateString
}>()


const headline = computed(() => {
    return `Krank melden`
})

const modal = ref()
const modalValue: Ref<boolean> = ref(true)

const onClick = () => {
    modalValue.value = true
}

</script>
<style lang="scss" scoped>
.headline {
    margin-bottom: 0.5em;
}
</style>
